export default "__VITE_ASSET__BSJuz0c9__"